import { render, staticRenderFns } from "./EmployeeStatusDetail.vue?vue&type=template&id=f53fd3e2&"
import script from "./EmployeeStatusDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeStatusDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports